import CountryList from 'country-list-with-dial-code-and-flag'

export default (ctx, inject) => {
	inject('CountryList', CountryList)
}
